"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CsvParserStream = void 0;
var string_decoder_1 = require("string_decoder");
var stream_1 = require("stream");
var transforms_1 = require("./transforms");
var parser_1 = require("./parser");
var CsvParserStream = /*#__PURE__*/function (_stream_1$Transform) {
  _inherits(CsvParserStream, _stream_1$Transform);
  var _super = _createSuper(CsvParserStream);
  function CsvParserStream(parserOptions) {
    var _this;
    _classCallCheck(this, CsvParserStream);
    _this = _super.call(this, {
      objectMode: parserOptions.objectMode
    });
    _this.lines = '';
    _this.rowCount = 0;
    _this.parsedRowCount = 0;
    _this.parsedLineCount = 0;
    _this.endEmitted = false;
    _this.headersEmitted = false;
    _this.parserOptions = parserOptions;
    _this.parser = new parser_1.Parser(parserOptions);
    _this.headerTransformer = new transforms_1.HeaderTransformer(parserOptions);
    _this.decoder = new string_decoder_1.StringDecoder(parserOptions.encoding);
    _this.rowTransformerValidator = new transforms_1.RowTransformerValidator();
    return _this;
  }
  _createClass(CsvParserStream, [{
    key: "hasHitRowLimit",
    get: function get() {
      return this.parserOptions.limitRows && this.rowCount >= this.parserOptions.maxRows;
    }
  }, {
    key: "shouldEmitRows",
    get: function get() {
      return this.parsedRowCount > this.parserOptions.skipRows;
    }
  }, {
    key: "shouldSkipLine",
    get: function get() {
      return this.parsedLineCount <= this.parserOptions.skipLines;
    }
  }, {
    key: "transform",
    value: function transform(transformFunction) {
      this.rowTransformerValidator.rowTransform = transformFunction;
      return this;
    }
  }, {
    key: "validate",
    value: function validate(validateFunction) {
      this.rowTransformerValidator.rowValidator = validateFunction;
      return this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {
    key: "emit",
    value: function emit(event) {
      var _get2;
      if (event === 'end') {
        if (!this.endEmitted) {
          this.endEmitted = true;
          _get(_getPrototypeOf(CsvParserStream.prototype), "emit", this).call(this, 'end', this.rowCount);
        }
        return false;
      }
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      return (_get2 = _get(_getPrototypeOf(CsvParserStream.prototype), "emit", this)).call.apply(_get2, [this, event].concat(rest));
    }
  }, {
    key: "_transform",
    value: function _transform(data, encoding, done) {
      // if we have hit our maxRows parsing limit then skip parsing
      if (this.hasHitRowLimit) {
        return done();
      }
      var wrappedCallback = CsvParserStream.wrapDoneCallback(done);
      try {
        var lines = this.lines;
        var newLine = lines + this.decoder.write(data);
        var rows = this.parse(newLine, true);
        return this.processRows(rows, wrappedCallback);
      } catch (e) {
        return wrappedCallback(e);
      }
    }
  }, {
    key: "_flush",
    value: function _flush(done) {
      var wrappedCallback = CsvParserStream.wrapDoneCallback(done);
      // if we have hit our maxRows parsing limit then skip parsing
      if (this.hasHitRowLimit) {
        return wrappedCallback();
      }
      try {
        var newLine = this.lines + this.decoder.end();
        var rows = this.parse(newLine, false);
        return this.processRows(rows, wrappedCallback);
      } catch (e) {
        return wrappedCallback(e);
      }
    }
  }, {
    key: "parse",
    value: function parse(data, hasMoreData) {
      if (!data) {
        return [];
      }
      var _this$parser$parse = this.parser.parse(data, hasMoreData),
        line = _this$parser$parse.line,
        rows = _this$parser$parse.rows;
      this.lines = line;
      return rows;
    }
  }, {
    key: "processRows",
    value: function processRows(rows, cb) {
      var _this2 = this;
      var rowsLength = rows.length;
      var iterate = function iterate(i) {
        var callNext = function callNext(err) {
          if (err) {
            return cb(err);
          }
          if (i % 100 === 0) {
            // incase the transform are sync insert a next tick to prevent stack overflow
            setImmediate(function () {
              return iterate(i + 1);
            });
            return undefined;
          }
          return iterate(i + 1);
        };
        _this2.checkAndEmitHeaders();
        // if we have emitted all rows or we have hit the maxRows limit option
        // then end
        if (i >= rowsLength || _this2.hasHitRowLimit) {
          return cb();
        }
        _this2.parsedLineCount += 1;
        if (_this2.shouldSkipLine) {
          return callNext();
        }
        var row = rows[i];
        _this2.rowCount += 1;
        _this2.parsedRowCount += 1;
        var nextRowCount = _this2.rowCount;
        return _this2.transformRow(row, function (err, transformResult) {
          if (err) {
            _this2.rowCount -= 1;
            return callNext(err);
          }
          if (!transformResult) {
            return callNext(new Error('expected transform result'));
          }
          if (!transformResult.isValid) {
            _this2.emit('data-invalid', transformResult.row, nextRowCount, transformResult.reason);
          } else if (transformResult.row) {
            return _this2.pushRow(transformResult.row, callNext);
          }
          return callNext();
        });
      };
      iterate(0);
    }
  }, {
    key: "transformRow",
    value: function transformRow(parsedRow, cb) {
      var _this3 = this;
      try {
        this.headerTransformer.transform(parsedRow, function (err, withHeaders) {
          if (err) {
            return cb(err);
          }
          if (!withHeaders) {
            return cb(new Error('Expected result from header transform'));
          }
          if (!withHeaders.isValid) {
            if (_this3.shouldEmitRows) {
              return cb(null, {
                isValid: false,
                row: parsedRow
              });
            }
            // skipped because of skipRows option remove from total row count
            return _this3.skipRow(cb);
          }
          if (withHeaders.row) {
            if (_this3.shouldEmitRows) {
              return _this3.rowTransformerValidator.transformAndValidate(withHeaders.row, cb);
            }
            // skipped because of skipRows option remove from total row count
            return _this3.skipRow(cb);
          }
          // this is a header row dont include in the rowCount or parsedRowCount
          _this3.rowCount -= 1;
          _this3.parsedRowCount -= 1;
          return cb(null, {
            row: null,
            isValid: true
          });
        });
      } catch (e) {
        cb(e);
      }
    }
  }, {
    key: "checkAndEmitHeaders",
    value: function checkAndEmitHeaders() {
      if (!this.headersEmitted && this.headerTransformer.headers) {
        this.headersEmitted = true;
        this.emit('headers', this.headerTransformer.headers);
      }
    }
  }, {
    key: "skipRow",
    value: function skipRow(cb) {
      // skipped because of skipRows option remove from total row count
      this.rowCount -= 1;
      return cb(null, {
        row: null,
        isValid: true
      });
    }
  }, {
    key: "pushRow",
    value: function pushRow(row, cb) {
      try {
        if (!this.parserOptions.objectMode) {
          this.push(JSON.stringify(row));
        } else {
          this.push(row);
        }
        cb();
      } catch (e) {
        cb(e);
      }
    }
  }], [{
    key: "wrapDoneCallback",
    value: function wrapDoneCallback(done) {
      var errorCalled = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return function (err) {
        if (err) {
          if (errorCalled) {
            throw err;
          }
          errorCalled = true;
          done(err);
          return;
        }
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        done.apply(void 0, args);
      };
    }
  }]);
  return CsvParserStream;
}(stream_1.Transform);
exports.CsvParserStream = CsvParserStream;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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